import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu, Popover } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
// import { v4 as uuidv4 } from "uuid";

import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { downloadResource } from "../../utils";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForwardModal from "../../components/ForwardMessageModal";
import ShowTicketOpen from "../ShowTicketOpenModal";
import AcceptTicketWithoutQueue from "../AcceptTicketWithoutQueueModal";

import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

const QUICK_REACTIONS = ["\u{1F44D}", "\u{2764}\u{FE0F}", "\u{1F602}", "\u{1F62E}", "\u{1F622}"];

const useStyles = makeStyles((theme) => ({
  quickReactionsRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 6,
    padding: "6px 12px",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  quickReactionBtn: {
    fontSize: 22,
    cursor: "pointer",
    padding: "4px 6px",
    borderRadius: 8,
    border: "none",
    backgroundColor: "transparent",
    transition: "background-color 0.15s, transform 0.15s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.25)",
    },
  },
  moreEmojiBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 32,
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    marginLeft: 4,
    backgroundColor: theme.mode === "light" ? "#e0e0e0" : "#3a3f47",
    color: theme.mode === "light" ? "#555" : "#ccc",
    fontSize: 18,
    fontWeight: 600,
    transition: "background-color 0.15s, transform 0.15s",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#d0d0d0" : "#4a4f57",
      transform: "scale(1.15)",
    },
  },
}));

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  isGroup,
  queueId,
  whatsappId
}) => {
  const classes = useStyles();
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext ? editingContext.setEditingMessage : null;
  const { setTabOpen } = useContext(TicketsContext);
  const history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);
  const [emojiPickerAnchor, setEmojiPickerAnchor] = useState(null);

  const { showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen } = useContext(ForwardMessageContext);

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
        queueId: queueId,
        whatsappId: whatsappId
      });

      setTicketOpen(ticket);
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen("open");
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      const ticket = JSON.parse(err.response.data.error);

      if (ticket.userId !== user?.id) {
        setOpenAlert(true);
        setUserTicketOpen(ticket.user.name);
        setQueueTicketOpen(ticket.queue.name);
      } else {
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");

        // handleSelectTicket(ticket);
        setTabOpen(ticket.status);
        history.push(`/tickets/${ticket.uuid}`);
      }
    }
    //setLoading(false);
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSetShowSelectCheckbox = () => {
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = async () => {
    setEditingMessage(message);
    handleClose();
  }
  // const handleForwardMessage = (msg) => {
  //   setForwardModalOpen(true);
  //   setForwardMessage(msg);
  //   handleClose();
  // };
  // const handleCloseForwardModal = () => {

  //   //setSelectedSchedule(null);
  //   setForwardModalOpen(false);
  //   handleClose();
  // };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleReactMessage = async (emoji) => {
    try {
      await api.post(`/messages/${message.id}/react`, { emoji });
    } catch (err) {
      toastError(err);
    }
    setEmojiPickerAnchor(null);
    handleClose();
  };

  const handleOpenEmojiPicker = (event) => {
    setEmojiPickerAnchor(event.currentTarget);
  };

  const handleCloseEmojiPicker = () => {
    setEmojiPickerAnchor(null);
  };

  const handleEmojiSelect = (e) => {
    handleReactMessage(e.native);
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000; // 15 minutos em milissegundos
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    // Verifica se a diferença entre o tempo atual e o tempo da mensagem é menor que 15 minutos
    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  const handleCopyMessage = () => {
    navigator.clipboard.writeText(message.body);
    toast.success(i18n.t("messageOptionsMenu.copied"));
    handleClose();
  };

  const handleDownloadMedia = () => {
    try {
      const url = message.mediaUrl;
      const filename = url.split("/").pop() || message.body || "download";
      downloadResource(url, filename);
    } catch (err) {
      toastError(err);
    }
    handleClose();
  };

  const hasMedia = message.mediaUrl && !message.isDeleted;

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  return (
    <>
      <AcceptTicketWithoutQueue
        modalOpen={acceptTicketWithouSelectQueueOpen}
        onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
        ticket={ticketOpen}
        ticketId={ticketOpen?.id}
      />
      <ShowTicketOpen
        isOpen={openAlert}
        handleClose={handleCloseAlert}
        user={userTicketOpen}
        queue={queueTicketOpen}
      />
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>

      <ForwardModal
        modalOpen={forwardMessageModalOpen}
        messages={selectedMessages}
        onClose={(e) => {
          setForwardMessageModalOpen(false);
          setShowSelectMessageCheckbox(false);
        }}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
        PaperProps={{ style: { minWidth: 300 } }}
      >
        {!message.isDeleted && !message.isPrivate && (
          <div className={classes.quickReactionsRow}>
            {QUICK_REACTIONS.map((emoji) => (
              <button
                key={emoji}
                className={classes.quickReactionBtn}
                onClick={() => handleReactMessage(emoji)}
                title={emoji}
              >
                {emoji}
              </button>
            ))}
            <button
              className={classes.moreEmojiBtn}
              onClick={handleOpenEmojiPicker}
              title="Mais"
            >
              +
            </button>
          </div>
        )}
        {message.fromMe && (
          <MenuItem key="delete" onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && isWithinFifteenMinutes() && (
          <MenuItem key="edit" onClick={handleEditMessage}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {message.body && !message.isDeleted && (
          <MenuItem onClick={handleCopyMessage}>
            <ListItemIcon style={{ minWidth: 36 }}>
              <FileCopyOutlinedIcon fontSize="small" />
            </ListItemIcon>
            {i18n.t("messageOptionsMenu.copy")}
          </MenuItem>
        )}
        {hasMedia && (
          <MenuItem onClick={handleDownloadMedia}>
            <ListItemIcon style={{ minWidth: 36 }}>
              <GetAppIcon fontSize="small" />
            </ListItemIcon>
            {i18n.t("messageOptionsMenu.download")}
          </MenuItem>
        )}
        <MenuItem onClick={handleSetShowSelectCheckbox}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        {!message.fromMe && isGroup && (
          <MenuItem onClick={() => handleSaveTicket(message?.contact?.id)}>
            {i18n.t("messageOptionsMenu.talkTo")}
          </MenuItem>
        )}
      </Menu>
      <Popover
        open={Boolean(emojiPickerAnchor)}
        anchorEl={emojiPickerAnchor}
        onClose={handleCloseEmojiPicker}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Picker
          perLine={9}
          theme={"dark"}
          showPreview={false}
          showSkinTones={false}
          onSelect={handleEmojiSelect}
        />
      </Popover>
    </>
  );
};

export default MessageOptionsMenu;
